import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../components/ui/button";
import { useSEO } from "../lib/useSEO";

export default function NotFoundPage() {
  const { t } = useTranslation();
  useSEO({ title: t("nf.title"), description: t("nf.desc") });
  return (
    <div data-testid="not-found-page" className="min-h-[80vh] pt-32 pb-20 flex items-center">
      <div className="container-icb text-center max-w-xl">
        <p className="font-serif text-[160px] leading-none text-brand-500/10 select-none">404</p>
        <h1 className="font-serif text-4xl md:text-5xl text-brand-500 mt-[-60px] mb-4">{t("nf.title")}</h1>
        <p className="text-slate-600 mb-8">{t("nf.desc")}</p>
        <Link to="/"><Button data-testid="404-home-cta" className="bg-brand-500 hover:bg-brand-600 text-white">{t("nf.cta")}</Button></Link>
      </div>
    </div>
  );
}
